<template>
  <div
    v-if="isVisible"
    class="mb-32 mt-16 bg-blue-600 p-20 lg:fixed lg:bottom-112 lg:right-0 lg:z-40 lg:m-0 lg:rounded-l-large"
  >
    <div class="">
      <button
        class="float-right hidden size-24 rounded-full lg:block"
        type="button"
        :aria-label="$texts('close')"
        @click.prevent="quickLinksClose"
      >
        <SpriteSymbol
          name="cancel"
          class="size-full text-white"
          aria-hidden="true"
        />
      </button>

      <p class="typo-h4 text-white">{{ title }}</p>

      <DrupalLink v-if="to" :to="to" class="button is-primary mt-20">
        <div v-if="page === 'home'" class="icon">
          <SpriteSymbol name="lock" />
        </div>
        <span>{{ linktext }}</span>
      </DrupalLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useLocalStorage } from '@vueuse/core'

const { $texts } = useEasyTexts()

const isVisibleValue = useLocalStorage<'yes' | 'no'>('quickLinksVisible', 'yes')

const isVisible = computed(() => isVisibleValue.value === 'yes')

defineProps<{
  to: string
  title: string
  linktext: string
  page: string
}>()

function quickLinksClose() {
  isVisibleValue.value = 'no'
}
</script>
